// Extracted from BatucadaRio.jsx — GroupEditorTab

import React, { useState, useEffect, useRef, useCallback } from 'react';
import * as Tone from 'tone';
import {
  Play, Pause, Square, Volume2, Search, Download, Settings, ArrowLeft,
  Drum, Clock, SkipBack, Repeat, Layers, ChevronLeft, ChevronRight,
  Sliders, Grid3X3, FileAudio, Code, Package, FolderUp, Save, ChevronUp, ChevronDown,
  Trash2, X
} from 'lucide-react';
import { toast } from 'sonner';

// ============================================
// GROUP EDITOR TAB (Placeholder)
// ============================================
export const GROUP_NAMES = { 1: 'Main', 2: 'Release', 3: 'Percussion', 4: 'FX' };

export const GroupEditorTab = ({ sample, selectedKey, settings, keyMappings, keySettings, onTrimChange, groupSettings, onGroupSettingsChange }) => {
  const currentGroup = settings?.group || 1;
  const keysInGroup = (g) => Object.keys(keyMappings || {}).filter(k => ((keySettings?.[k]?.group) || 1) === g);

  const assignToGroup = (g) => {
    if (!selectedKey) return;
    onTrimChange(selectedKey, { ...(settings || {}), group: g });
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="group-editor">
      {[1, 2, 3, 4].map((g) => {
        const gs = groupSettings?.[g] || { volume: 0, mute: false, solo: false };
        const keys = keysInGroup(g);
        const isCurrent = currentGroup === g;
        return (
          <div
            key={g}
            className={`bg-[#222] rounded-lg p-3 border ${isCurrent ? 'border-amber-500' : 'border-[#333]'}`}
            data-testid={`group-card-${g}`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className={`text-xs font-bold ${isCurrent ? 'text-amber-400' : 'text-white'}`}>
                Group {g} - {GROUP_NAMES[g]}
              </span>
              <div className="flex gap-1">
                <button
                  onClick={() => onGroupSettingsChange(g, { mute: !gs.mute })}
                  className={`w-6 h-6 rounded text-[10px] font-bold ${gs.mute ? 'bg-red-500 text-white' : 'bg-[#333] text-gray-400 hover:bg-[#444]'}`}
                  title="Mute group"
                  data-testid={`group-${g}-mute-btn`}
                >
                  M
                </button>
                <button
                  onClick={() => onGroupSettingsChange(g, { solo: !gs.solo })}
                  className={`w-6 h-6 rounded text-[10px] font-bold ${gs.solo ? 'bg-yellow-500 text-black' : 'bg-[#333] text-gray-400 hover:bg-[#444]'}`}
                  title="Solo group"
                  data-testid={`group-${g}-solo-btn`}
                >
                  S
                </button>
              </div>
            </div>

            <div className="mb-2">
              <div className="flex justify-between text-[10px] text-gray-500 mb-1">
                <span>VOLUME</span>
                <span className="text-amber-400">{gs.volume > 0 ? '+' : ''}{gs.volume} dB</span>
              </div>
              <input
                type="range"
                min={-24}
                max={24}
                step={1}
                value={gs.volume}
                onChange={(e) => onGroupSettingsChange(g, { volume: Number(e.target.value) })}
                className="w-full accent-amber-500 h-1"
                data-testid={`group-${g}-volume-slider`}
              />
            </div>

            <div className="mb-2 min-h-[28px]">
              <div className="text-[9px] text-gray-500 mb-1">{keys.length} KEY{keys.length === 1 ? '' : 'S'}</div>
              <div className="flex flex-wrap gap-1">
                {keys.slice(0, 8).map(k => (
                  <span key={k} className={`px-1.5 py-0.5 rounded text-[9px] ${k === selectedKey ? 'bg-amber-500 text-black font-bold' : 'bg-[#333] text-gray-400'}`}>
                    {k}
                  </span>
                ))}
                {keys.length > 8 && <span className="text-[9px] text-gray-500">+{keys.length - 8}</span>}
              </div>
            </div>

            <button
              onClick={() => assignToGroup(g)}
              disabled={!selectedKey || isCurrent}
              className={`w-full py-1 rounded text-[10px] font-bold transition-colors
                ${isCurrent ? 'bg-amber-500/20 text-amber-400 cursor-default' : 'bg-[#333] text-white hover:bg-amber-500 hover:text-black'}`}
              data-testid={`group-${g}-assign-btn`}
            >
              {isCurrent ? `${selectedKey} IS HERE` : `ASSIGN ${selectedKey || ''}`}
            </button>
          </div>
        );
      })}
    </div>
  );
};
